function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.401 22.085c0 8.962 7.266 16.23 16.229 16.23 8.966 0 16.232-7.268 16.232-16.23 0-8.965-7.266-16.23-16.232-16.23",
  fill: "none",
  stroke: "#231f20"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M52.943 10.964c-5.964 5.235-6.482 14.397-1.155 20.463 5.328 6.063 14.478 6.737 20.441 1.5 5.963-5.238 6.479-14.398 1.153-20.463",
  fill: "none",
  stroke: "#7e8959"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.639 38.453V15.995a8.266 8.266 0 10-16.531 0M24.07 38.262v-22.46a8.266 8.266 0 00-16.533 0v22.46",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 1.5
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.793 15.014c0-1.216-.16-2.342-.479-3.379-.316-1.036-.793-1.928-1.428-2.673-.638-.747-1.447-1.333-2.427-1.762-.98-.428-2.146-.643-3.502-.643a9.906 9.906 0 00-2.985.457 7.86 7.86 0 00-2.57 1.346 6.45 6.45 0 00-1.782 2.26c-.442.912-.663 1.976-.663 3.192 0 2.404.939 4.255 2.818 5.554.636.415 1.374.774 2.219 1.077.842.305 1.886.554 3.129.748 1.574.22 2.936.58 4.083 1.077 1.148.497 2.038 1.148 2.675 1.948 1.133 1.327 1.699 3.123 1.699 5.389 0 1.299-.229 2.44-.683 3.421a7.257 7.257 0 01-1.847 2.467c-.774.662-1.686 1.167-2.735 1.511a10.558 10.558 0 01-3.316.518c-1.245 0-2.398-.206-3.463-.621a8.53 8.53 0 01-2.796-1.761 9.206 9.206 0 01-1.969-2.736c-.513-1.064-.835-2.232-.975-3.503l.414-.125a9.18 9.18 0 00.828 3.213 9.15 9.15 0 001.848 2.652 8.395 8.395 0 002.692 1.804c1.037.442 2.176.664 3.421.664a9.932 9.932 0 003.149-.497 7.751 7.751 0 002.614-1.452 6.794 6.794 0 001.76-2.342c.428-.926.642-1.996.642-3.213 0-1.161-.13-2.142-.393-2.943a6.697 6.697 0 00-1.222-2.197c-1.217-1.465-3.386-2.418-6.509-2.861-1.272-.193-2.335-.44-3.192-.745a10.145 10.145 0 01-2.322-1.161c-1.989-1.409-2.985-3.371-2.985-5.886 0-1.271.236-2.39.706-3.358a6.93 6.93 0 011.886-2.404 8.137 8.137 0 012.696-1.431 10.362 10.362 0 013.128-.476c2.68 0 4.711.808 6.093 2.425 1.382 1.617 2.101 3.751 2.155 6.404l-.412.042zM123.269 15.014c0-1.216-.16-2.342-.478-3.379-.318-1.036-.794-1.928-1.43-2.673-.638-.747-1.445-1.333-2.425-1.762-.981-.428-2.149-.643-3.503-.643a9.917 9.917 0 00-2.986.457 7.886 7.886 0 00-2.569 1.346 6.43 6.43 0 00-1.783 2.26c-.442.912-.663 1.976-.663 3.192 0 2.404.939 4.255 2.819 5.554.635.415 1.374.774 2.219 1.077.84.305 1.886.554 3.129.748 1.574.22 2.936.58 4.082 1.077 1.149.497 2.04 1.148 2.674 1.948 1.135 1.327 1.701 3.123 1.701 5.389 0 1.299-.229 2.44-.683 3.421a7.257 7.257 0 01-1.847 2.467c-.774.662-1.686 1.167-2.736 1.511a10.55 10.55 0 01-3.316.518c-1.243 0-2.397-.206-3.462-.621a8.55 8.55 0 01-2.798-1.761 9.239 9.239 0 01-1.968-2.736c-.511-1.064-.836-2.232-.975-3.503l.415-.125a9.117 9.117 0 00.829 3.213 9.14 9.14 0 001.845 2.652 8.432 8.432 0 002.693 1.804c1.037.442 2.178.664 3.421.664a9.942 9.942 0 003.15-.497 7.732 7.732 0 002.612-1.452 6.75 6.75 0 001.762-2.342c.428-.926.642-1.996.642-3.213 0-1.161-.13-2.142-.393-2.943a6.648 6.648 0 00-1.224-2.197c-1.216-1.465-3.385-2.418-6.507-2.861-1.272-.193-2.337-.44-3.192-.745a10.112 10.112 0 01-2.323-1.161c-1.988-1.409-2.984-3.371-2.984-5.886 0-1.271.236-2.39.704-3.358a6.95 6.95 0 011.889-2.404 8.146 8.146 0 012.694-1.431 10.364 10.364 0 013.129-.476c2.68 0 4.71.808 6.093 2.425 1.382 1.617 2.098 3.751 2.156 6.404l-.413.042z",
  fill: "#231f20",
  fillRule: "nonzero",
  stroke: "#231f20"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M79.359 37.479a2.747 2.747 0 11-3.859-.418 2.744 2.744 0 013.859.418",
  fill: "#7e8959",
  fillRule: "nonzero"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.773 27.135c2.699 6.447 10.264 9.423 16.892 6.647 6.628-2.777 9.814-10.254 7.115-16.7-2.698-6.445-10.263-9.42-16.893-6.646",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 0.25
});

function SvgLogoinline(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 130 46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 10
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgLogoinline;